import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class ReportsModule {
    constructor() {
        this.reports = [];
        this.count = 0;
        this.axiosError = null;
    }
    setItems(report) {
        this.reports = report;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.reports;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.reports.get(options);
            this.setItems(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async getReports(id) {
        try {
            const data = await service.reports.getReports(id);
            return Promise.resolve(data);
        }
        catch (error) {
            this.setError(error);
        }
    }
    async getReportsSysLog(options) {
        try {
            const data = await service.reports.getReportsSysLog(options);
            return Promise.resolve(data);
        }
        catch (error) {
            this.setError(error);
        }
    }
    async getReportsPassLog(options) {
        try {
            const data = await service.reports.getReportsPassLog(options);
            return Promise.resolve(data);
        }
        catch (error) {
            this.setError(error);
        }
    }
    async add(report) {
        try {
            await service.reports.add(report);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
        }
    }
    async edit(report) {
        try {
            await service.reports.edit(report);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
    async delete(report) {
        try {
            await service.reports.delete(report);
            return true;
        }
        catch (error) {
            this.setError(error);
            return false;
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
}
__decorate([
    State()
], ReportsModule.prototype, "reports", void 0);
__decorate([
    State()
], ReportsModule.prototype, "count", void 0);
__decorate([
    State()
], ReportsModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], ReportsModule.prototype, "setItems", null);
__decorate([
    Mutation()
], ReportsModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], ReportsModule.prototype, "setError", null);
__decorate([
    Getter()
], ReportsModule.prototype, "list", null);
__decorate([
    Getter()
], ReportsModule.prototype, "total", null);
__decorate([
    Getter()
], ReportsModule.prototype, "errorList", null);
__decorate([
    Action()
], ReportsModule.prototype, "get", null);
__decorate([
    Action()
], ReportsModule.prototype, "getReports", null);
__decorate([
    Action()
], ReportsModule.prototype, "getReportsSysLog", null);
__decorate([
    Action()
], ReportsModule.prototype, "getReportsPassLog", null);
__decorate([
    Action()
], ReportsModule.prototype, "add", null);
__decorate([
    Action()
], ReportsModule.prototype, "edit", null);
__decorate([
    Action()
], ReportsModule.prototype, "delete", null);
